import { PLAN_TYPES } from 'src/constants/cardsEnum';

export enum LemonsqueezySseEventApiResponse {
  subscription_updated = 'subscription_updated',
}

export enum LEMONSQUEEZY_PLAN_INTERVALS {
  month = 'month',
  year = 'year',
}

export type LemonsqueezySubscriptionStatus =
  | 'on_trial'
  | 'active'
  | 'paused'
  | 'pause'
  | 'past_due'
  | 'unpaid'
  | 'cancelled'
  | 'expired';

export interface CreateCheckoutPayload {
  selectedPlan: Exclude<keyof typeof PLAN_TYPES, 'FREE'>;
  quantity: string;
  selectedInterval: keyof typeof LEMONSQUEEZY_PLAN_INTERVALS;
  discountCode?: string;
}

export interface UpdateLemonsqueezySubscriptionPayload
  extends CreateCheckoutPayload {}

export interface LemonsqueezyInvoiceAttributes {
  invoice_number: string;
  status: string;
  status_formatted: string;
  total_formatted: string;
  urls: {
    invoice_url: string;
  };
  created_at: string;
}

export interface LemonsqueezyInvoice {
  id: string;
  attributes: LemonsqueezyInvoiceAttributes;
  [key: string]: unknown;
}

export interface LemonsqueezyInvoicesApiResponse {
  data: LemonsqueezyInvoice[];
  meta?: {
    page?: {
      total?: number;
      currentPage?: number;
      lastPage?: number;
      perPage?: number;
      from?: number;
      to?: number;
    };
  };
  [key: string]: unknown;
}

export type LemonSqueezyEventHandler = (data: string) => void;

export interface LemonSqueezySetupOptions {
  eventHandler?: LemonSqueezyEventHandler;
}

export interface LemonSqueezyCheckoutUrlParameters {
  variantId: string;
  quantity: string;
  orgId: string;
  discountCode?: string;
}

declare global {
  interface Window {
    createLemonSqueezy?: () => void;
    LemonSqueezy?: {
      Setup?: (options: LemonSqueezySetupOptions) => void;
      Url: {
        Open: (url: string) => void;
      };
    };
  }
}
